module.exports = __webpack_public_path__ + "media/B-A-005_SAF_BTB_PhishingInAction.b80fe7ab.mp4";